import { QRCodeSVG } from "qrcode.react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const Row = ({ label, value }) => (
  <div className="border-b border-slate-300 pb-1">
    <div className="text-[9px] font-bold tracking-[0.15em] text-slate-500">{label}</div>
    <div className="h-5 text-sm font-semibold text-[#16294A] truncate">{value}</div>
  </div>
);

export const CardBackPreview = ({ name, testid }) => (
  <div data-testid={testid} className="bg-white text-slate-800 rounded-xl p-4 w-full max-w-[340px] aspect-[1.586] flex flex-col shadow-lg">
    <div className="flex items-center justify-between border-b-2 border-[#D7263D] pb-1.5">
      <span className="text-[10px] font-black tracking-[0.2em] text-[#D7263D]">EMERGENCY MEDICAL ID</span>
      <span className="text-sm font-black text-[#16294A]">bsafe<span className="text-[10px] font-medium text-[#D7263D]">.today</span></span>
    </div>
    <div className="flex gap-3 mt-2 flex-1">
      <div className="flex-1 space-y-2"><Row label="NAME" value={name} /><Row label="BLOOD GROUP" value="" /><Row label="EMERGENCY CONTACT" value="" /></div>
      <div className="flex flex-col items-center">
        <div className="relative"><QRCodeSVG value="https://bsafe.today" size={70} fgColor="#16294A" />
          <span className="absolute inset-0 flex items-center justify-center"><span className="bg-[#D7263D] text-white text-[8px] font-bold px-1 rounded">SAMPLE</span></span></div>
        <span className="text-[8px] text-slate-500 mt-1">No NFC? Scan here</span>
      </div>
    </div>
    <div className="text-[8px] text-slate-500">bsafe.today · A product of <b>MUGAWE INVESTMENTS U LTD</b></div>
  </div>
);

export const CardHolder = ({ members, value, onChange, idx, card = true }) => (
  <div className="flex-1 min-w-[200px]">
    <div className="overline mb-2">{card ? "Name on the card back" : "Linked to"}</div>
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
      <SelectTrigger data-testid={`card-holder-select-${idx}`}><SelectValue /></SelectTrigger>
      <SelectContent><SelectItem value="none">Leave blank (assign later)</SelectItem>
        {members.map((m) => <SelectItem key={m.id} value={m.id}>{m.first_name} {m.last_name}</SelectItem>)}</SelectContent>
    </Select>
    <p className="text-xs text-slate-400 mt-2">{card ? "The QR shown is a sample. Your real QR code is created when the invoice is paid and printed on this card." : "This item gets the same QR and link as this profile."}</p>
  </div>
);

export const GiftFields = ({ gift, onChange, idx }) => {
  const set = (k) => (e) => onChange({ ...gift, [k]: e.target.value });
  return (
    <div className="grid sm:grid-cols-2 gap-3 w-full" data-testid={`gift-fields-${idx}`}>
      <Input data-testid={`gift-recipient-input-${idx}`} placeholder="Recipient name" maxLength={60} value={gift.recipient_name} onChange={set("recipient_name")} />
      <Input data-testid={`gift-whatsapp-input-${idx}`} placeholder="Recipient WhatsApp, e.g. +256 7XX XXX XXX" value={gift.whatsapp} onChange={set("whatsapp")} />
      <div className="sm:col-span-2">
        <Textarea data-testid={`gift-message-input-${idx}`} placeholder="Personal message (optional)" maxLength={200} rows={2} value={gift.message} onChange={set("message")} />
        <div className="text-xs text-slate-400 mt-1 flex justify-between"><span>Sent by WhatsApp when the invoice is paid.</span><span>{gift.message.length}/200</span></div>
      </div>
    </div>
  );
};
